import React from "react";
import { getTranslation } from "../TranslationWrapper/TranslationWrapper";
import * as actions from "../../store/actions";
import { connect } from "react-redux";
import { MenuItem, Select } from "@mui/material";
import { withStyles } from "tss-react/mui";
import productenStyle from "../../assets/jss/material-dashboard-pro-react/views/productStyle";

function ApiStatusFilter(props) {
  const { classes } = props;

  let value = "ALL";
  if (props["apiStatus"]?.value === 0) {
    value = "0";
  } else if (props["apiStatus"]?.value === 1) {
    value = "1";
  }

  const status = [
    {
      value: "ALL",
      label: getTranslation("bestellingen.filers.apiStatus.all", "All orders"),
    },
    {
      value: "1",
      label: getTranslation("bestellingen.filers.apiStatus.nonpaid", "Successful orders"),
    },
    {
      value: "0",
      label: getTranslation("bestellingen.filers.apiStatus.paid", "Failed and pending orders"),
    },
  ];

  return (
    <Select
      MenuProps={{
        className: classes.selectMenu,
      }}
      classes={{
        select: classes.select,
      }}
      inputProps={{
        name: "simpleSelect",
        id: "simple-select",
        style: { paddingTop: "32px" },
      }}
      onChange={(e) => {
        let selectedStatusOrder = e.target.value;

        switch (selectedStatusOrder) {
          case "ALL":
            props.setFilter("apiStatus", null);
            props.setFilter("queued", null);
            break;
          case "0":
            props.setFilter("apiStatus", { field: "apiStatus", operator: "=", value: 0 });
            props.setFilter("queued", { field: "queued", operator: "=", value: 0 });
            break;
          case "1":
            props.setFilter("apiStatus", { field: "apiStatus", operator: ">=", value: 1 });
            props.setFilter("queued", { field: "queued", operator: "=", value: 0 });
            break;
        }
      }}
      value={value}
    >
      {status.map((item) => (
        <MenuItem
          classes={{
            root: classes.selectMenuItem,
            selected: classes.selectMenuItemSelected,
          }}
          key={item.value}
          value={item.value}
        >
          {item.label}
        </MenuItem>
      ))}
    </Select>
  );
}

const mapStateToProps = (state) => ({
  ["apiStatus"]: state.filtersV2["apiStatus"],
});

const mapDispatchToProps = (dispatch) => ({
  setFilter: (key, filter) => {
    dispatch({
      type: actions.SET_FILTER,
      payload: { key, filter },
    });
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(ApiStatusFilter, productenStyle));
